export default {
  "H1D1M1P1S0": "57,26 €",
  "H1D1M1P1S1": "-",
  "H2D2M2P2S0": "59,60 €",
  "H2D2M2P2S1": "77,14 €",
  "H3D3M3P3S0": "63,13 €",
  "H3D3M3P3S1": "80,66 €",
  "H4D4M4P4S0": "76,30 €",
  "H4D4M4P4S1": "93,83 €",
  "H5D5M5P5S0": "84,69 €",
  "H5D5M5P5S1": "102,22 €",
  "H6D6M6P6S0": "95,07 €",
  "H6D6M6P6S1": "112,60 €",
  "H7D7M7P7S0": "110,67 €",
  "H7D7M7P7S1": "128,20 €",
  "H8D8M8P8S0": "132,99 €",
  "H8D8M8P8S1": "150,52 €"
}
